import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';

import {
  faEye,
  faHeartCrack,
  faHeart,
  faImages,
  faCalendarXmark,
  faHandsPraying,
  faFaceGrinHearts,
  faHandFist,
  faGaugeHigh,
  faDoorClosed,
  faImage,
  faUserCheck,
  faBaseball,
  faCar,
  faLanguage,
  faReceipt,
  faDoorOpen,
  faFloppyDisk,
  faFileSignature,
  faClipboard,
  faSquareCheck,
  faMugSaucer,
  faUser,
  faAngleRight,
  faChevronRight,
  faChevronLeft,
  faArrowLeft,
  faChevronDown,
  faPaintbrush,
  faPlus,
  faCalendar,
  faMagnifyingGlass,
  faClock,
  faPhone,
  faTrash,
  faPen,
  faBars,
  faUsers,
  faGear,
  faBookOpen,
  faRightFromBracket,
  faBriefcase,
  faNoteSticky,
  faChartColumn,
  faCakeCandles,
  faHandHoldingDollar,
  faDollarSign,
  faComment,
  faCreditCard,
  faCircle,
  faSort,
  faArrowDownWideShort,
  faArrowDown19,
  faArrowUp19,
  faArrowDownAZ,
  faArrowUpAZ,
  faCheck,
  faArrowDownZA,
  faArrowDown91,
  faChartLine,
  faChartPie,
  faCircleQuestion,
  faLock,
  faEnvelope,
  faIdBadge,
  faMobileScreenButton,
  faCloud,
  faTriangleExclamation,
  faXmark,
  faFileInvoiceDollar,
  faDumbbell,
  faScissors,
  faStethoscope,
  faTooth,
  faSyringe,
  faGuitar,
  faMicrophoneLines,
  faHands,
  faHammer,
  faCamera,
  faVideo,
  faPencil,
  faMoneyCheckDollar,
  faMessage,
  faArrowUp,
  faArrowDown,
  faMinus,
  faCircleInfo,
  faCalendarCheck,
  faCalendarPlus,
  faFileInvoice,
  faBook,
  faCaretDown,
  faUsersGear,
  faUserTie,
  faCalculator,
  faUserPen,
  faTag,
  faLocationDot,
  faClockRotateLeft,
  faGripLines,
  faBuildingColumns,
  faCirclePlus,
  faCrown,
  faCartShopping,
  faBox,
  faRotate,
  faCube,
  faCubes,
  faCartArrowDown,
  faCalendarDay,
  faCalendarWeek,
  faCalendarDays,
  faCopy,
  faUserSecret,
  faThumbtack,
  faCircleCheck,
  faCircleStop,
  faPercent,
  faGlobe,
  faSun,
  faChampagneGlasses,
  faTableTennisPaddleBall,
  faAddressCard,
  faDownload,
  faUpload,
  faFileArrowUp,
  faArrowRight,
  faAnglesUp,
  faDesktop,
  faBell,
  faPaperPlane,
  faToggleOn,
  faToggleOff,
  faBuilding,
  faAsterisk,
  faBoxesStacked,
  faUserGroup,
  faGift,
  faUserPlus,
  faCloudArrowUp,
  faCoins,
  faCircleExclamation,
  faLayerGroup,
  faHandHolding,
  faTurnUp,
  faArrowTrendUp,
  faArrowTrendDown,
  faFileExport,
  faPaw,
  faFutbol,
  faVolleyball,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCircle as farCircle,
  faSquare as farSquare,
  faPaperPlane as farPaperPlane,
  faStar as farStar,
} from '@fortawesome/free-regular-svg-icons';

import { faCourtSport, faMustache, faRacquet, faTennisBall, faWhistle } from '@fortawesome/pro-solid-svg-icons';

library.add(
  faEye,
  faHeartCrack,
  faHeart,
  faImages,
  faCalendarXmark,
  faHandsPraying,
  faFaceGrinHearts,
  faHandFist,
  faGaugeHigh,
  faDoorClosed,
  faUserCheck,
  faBuilding,
  faImage,
  faBaseball,
  faCar,
  faLanguage,
  faReceipt,
  faDoorOpen,
  farStar,
  faFloppyDisk,
  faFileSignature,
  faClipboard,
  fab,
  faSquareCheck,
  faMugSaucer,
  faUser,
  faAngleRight,
  faChevronRight,
  faChevronLeft,
  faArrowLeft,
  faArrowRight,
  faPaintbrush,
  faPlus,
  faCalendar,
  faChevronDown,
  faMagnifyingGlass,
  faClock,
  faPhone,
  faTrash,
  faPen,
  faBars,
  faUsers,
  faGear,
  faBookOpen,
  faRightFromBracket,
  faBriefcase,
  faNoteSticky,
  faChartColumn,
  faCakeCandles,
  faHandHoldingDollar,
  faDollarSign,
  faComment,
  faCreditCard,
  faCircle,
  faSort,
  faArrowDownWideShort,
  faArrowUpAZ,
  faArrowDownAZ,
  faArrowDownZA,
  faArrowDown19,
  faArrowDown91,
  faArrowUp19,
  faCheck,
  faChartColumn,
  faChartLine,
  faChartPie,
  faCircleQuestion,
  faLock,
  faEnvelope,
  faIdBadge,
  faMobileScreenButton,
  faCloud,
  faTriangleExclamation,
  faXmark,
  faFileInvoiceDollar,
  faDumbbell,
  faScissors,
  faStethoscope,
  faTooth,
  faSyringe,
  faGuitar,
  faMicrophoneLines,
  faHands,
  faHammer,
  faCamera,
  faVideo,
  faPencil,
  faMoneyCheckDollar,
  faMessage,
  faArrowUp,
  faArrowDown,
  faMinus,
  faCircleInfo,
  faCalendarCheck,
  faCalendarPlus,
  faFileInvoice,
  faBook,
  faCaretDown,
  faUsersGear,
  faUserTie,
  faCalculator,
  faUserPen,
  faTag,
  faLocationDot,
  faClockRotateLeft,
  faGripLines,
  faBuildingColumns,
  faCirclePlus,
  faCrown,
  faCartShopping,
  faBox,
  faRotate,
  faCube,
  faCubes,
  faCartArrowDown,
  faCalendarDay,
  faCalendarWeek,
  faCalendarDays,
  faCopy,
  faUserSecret,
  faThumbtack,
  faCircleCheck,
  faCircleStop,
  faPercent,
  faGlobe,
  faSun,
  faChampagneGlasses,
  faTableTennisPaddleBall,
  faAddressCard,
  farCircle,
  farSquare,
  farPaperPlane,
  faDownload,
  faUpload,
  faFileArrowUp,
  faAnglesUp,
  faDesktop,
  faBell,
  faPaperPlane,
  faToggleOn,
  faToggleOff,
  faAsterisk,
  faBoxesStacked,
  faUserGroup,
  faGift,
  faUserPlus,
  faCloudArrowUp,
  faCoins,
  faCircleExclamation,
  faLayerGroup,
  faHandHolding,
  faTurnUp,
  faArrowTrendUp,
  faArrowTrendDown,
  faFileExport,
  faPaw,
  faCourtSport,
  faMustache,
  faRacquet,
  faFutbol,
  faVolleyball,
  faTennisBall,
  faWhistle,
);
